// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-panel[data-v-b88a00b8]{border:1px solid #ccc;height:350px;padding:5px;overflow:auto}", ""]);
// Exports
module.exports = exports;
